import { CommonEnums } from '../../common.enums';

export class DObj {
    dObj_Id: number;
    nm: string;
    aliasNm: string;
    description: string;
    ver: string;
    dbTyp_Id: number;
    valid_Cd: string;
    localFlag: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    dObj_ParamNm: string;
    codepage: string;

    conn_Id: number;
    conn_Nm: string;
    conn_Db_Id: number;
    conn_DbNm: string;
    conn_DbTyp_Id: number;
    conn_Usr: string;
    conn_Db_FriendlyName: string;

    transient_ScopeFlg: string;
    caseSensitiveFlg: string;
    isPublicSynonym: string;
    cdcFlag: string;
    support_Net_Changes: string;
    capture_Instance: string;
    reNameDobj: string;
    host: string;
    port: string;
    ref_Id: number;
    ref_Cd: string;
    databaseNm: string;
    secKeyTab: string;
    platform: string;
    hiveServe2HACnf_Flg: string;
    zookeeper_Quorum_Host: string;
    instSqlNm: string;
    connType: string;
    originalTableName: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.updateDt = new Date();

        this.dObj_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.localFlag = CommonEnums.defaults.SUCCESS_CODE;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.dObj_ParamNm = CommonEnums.defaults.STRING_EMPTY;
        this.codepage = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.transient_ScopeFlg = 'P';
        this.caseSensitiveFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.isPublicSynonym = CommonEnums.defaults.STRING_VAL_NO;
        this.cdcFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.support_Net_Changes = CommonEnums.defaults.STRING_VAL_NO;
        this.capture_Instance = CommonEnums.defaults.STRING_EMPTY;
        this.reNameDobj = CommonEnums.defaults.STRING_EMPTY;
        this.conn_DbNm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_DbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.host = CommonEnums.defaults.STRING_EMPTY;
        this.port = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Usr = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.databaseNm = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_FriendlyName = CommonEnums.defaults.STRING_EMPTY;
        this.secKeyTab = CommonEnums.defaults.STRING_EMPTY;
        this.platform = CommonEnums.defaults.STRING_EMPTY;
        this.hiveServe2HACnf_Flg = CommonEnums.defaults.STRING_VAL_NO;
        this.zookeeper_Quorum_Host = CommonEnums.defaults.STRING_EMPTY;
        this.instSqlNm = CommonEnums.defaults.STRING_EMPTY;
        this.connType = CommonEnums.defaults.STRING_EMPTY;
        this.originalTableName =  CommonEnums.defaults.STRING_EMPTY;
    }

    getPrimaryKey(): string {
        return this.dObj_Id.toString();
    }

    static parse(dObjTmp: DObj): DObj {
        let dObj: DObj = new DObj();
        dObj.copyFrom(dObjTmp);
        return dObj;
    }

    copy(): DObj {
        let dObjTmp = new DObj();

        dObjTmp.dObj_Id = this.dObj_Id;
        dObjTmp.nm = this.nm;
        dObjTmp.aliasNm = this.aliasNm;
        dObjTmp.description = this.description;
        dObjTmp.ver = this.ver;
        dObjTmp.dbTyp_Id = this.dbTyp_Id;
        dObjTmp.valid_Cd = this.valid_Cd;
        dObjTmp.localFlag = this.localFlag;
        dObjTmp.updateBy = this.updateBy;
        dObjTmp.lastUpdateBy = this.lastUpdateBy;
        dObjTmp.updateDt = this.updateDt;
        dObjTmp.dObj_ParamNm = this.dObj_ParamNm;
        dObjTmp.codepage = this.codepage;
        dObjTmp.conn_Id = this.conn_Id;
        dObjTmp.conn_Db_Id = this.conn_Db_Id;
        dObjTmp.transient_ScopeFlg = this.transient_ScopeFlg;
        dObjTmp.caseSensitiveFlg = this.caseSensitiveFlg;
        dObjTmp.isPublicSynonym = this.isPublicSynonym;
        dObjTmp.cdcFlag = this.cdcFlag;
        dObjTmp.support_Net_Changes = this.support_Net_Changes;
        dObjTmp.capture_Instance = this.capture_Instance;
        dObjTmp.reNameDobj = this.reNameDobj;
        dObjTmp.conn_DbNm = this.conn_DbNm;
        dObjTmp.conn_DbTyp_Id = this.conn_DbTyp_Id;
        dObjTmp.conn_Nm = this.conn_Nm;
        dObjTmp.host = this.host;
        dObjTmp.port = this.port;
        dObjTmp.conn_Usr = this.conn_Usr;
        dObjTmp.ref_Id = this.ref_Id;
        dObjTmp.ref_Cd = this.ref_Cd;
        dObjTmp.databaseNm = this.databaseNm;
        dObjTmp.conn_Db_FriendlyName = this.conn_Db_FriendlyName;
        dObjTmp.secKeyTab = this.secKeyTab;
        dObjTmp.platform = this.platform;
        dObjTmp.hiveServe2HACnf_Flg = this.hiveServe2HACnf_Flg;
        dObjTmp.zookeeper_Quorum_Host = this.zookeeper_Quorum_Host;
        dObjTmp.instSqlNm = this.instSqlNm;
        dObjTmp.connType = this.connType;
        dObjTmp.originalTableName = this.originalTableName;
        return dObjTmp;
    }

    copyFrom(dObjTmp: DObj): void {
        this.dObj_Id = dObjTmp.dObj_Id;
        this.nm = dObjTmp.nm;
        this.aliasNm = dObjTmp.aliasNm;
        this.description = dObjTmp.description;
        this.ver = dObjTmp.ver;
        this.dbTyp_Id = dObjTmp.dbTyp_Id;
        this.valid_Cd = dObjTmp.valid_Cd;
        this.localFlag = dObjTmp.localFlag;
        this.updateBy = dObjTmp.updateBy;
        this.lastUpdateBy = dObjTmp.lastUpdateBy;
        this.updateDt = dObjTmp.updateDt;
        this.dObj_ParamNm = dObjTmp.dObj_ParamNm;
        this.codepage = dObjTmp.codepage;
        this.conn_Id = dObjTmp.conn_Id;
        this.conn_Db_Id = dObjTmp.conn_Db_Id;
        this.transient_ScopeFlg = dObjTmp.transient_ScopeFlg;
        this.caseSensitiveFlg = dObjTmp.caseSensitiveFlg;
        this.isPublicSynonym = dObjTmp.isPublicSynonym;
        this.cdcFlag = dObjTmp.cdcFlag;
        this.support_Net_Changes = dObjTmp.support_Net_Changes;
        this.capture_Instance = dObjTmp.capture_Instance;
        this.reNameDobj = dObjTmp.reNameDobj;
        this.conn_DbNm = dObjTmp.conn_DbNm;
        this.conn_DbTyp_Id = dObjTmp.conn_DbTyp_Id;
        this.conn_Nm = dObjTmp.conn_Nm;
        this.host = dObjTmp.host;
        this.port = dObjTmp.port;
        this.conn_Usr = dObjTmp.conn_Usr;
        this.ref_Id = dObjTmp.ref_Id;
        this.ref_Cd = dObjTmp.ref_Cd;
        this.databaseNm = dObjTmp.databaseNm;
        this.conn_Db_FriendlyName = dObjTmp.conn_Db_FriendlyName;
        this.secKeyTab = dObjTmp.secKeyTab;
        this.platform = dObjTmp.platform;
        this.hiveServe2HACnf_Flg = dObjTmp.hiveServe2HACnf_Flg;
        this.zookeeper_Quorum_Host = dObjTmp.zookeeper_Quorum_Host;
        this.instSqlNm = dObjTmp.instSqlNm;
        this.connType = dObjTmp.connType;
        this.originalTableName = dObjTmp.originalTableName;
    }

    compare(dObjTmp: DObj): string {
        let dObjString: string = this.toString(false);
        let dObjTmpString: string = dObjTmp.toString(false);

        if (dObjString != dObjTmpString) {
            return dObjString + ', ' + dObjTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DObj [dObj_Id=" + this.dObj_Id + ", nm=" + this.nm + ", aliasNm=" + this.aliasNm + ", description=" + this.description +
            ", ver =" + this.ver + ", dbTyp_Id=" + this.dbTyp_Id + ", localFlag=" + this.localFlag + ", valid_Cd=" + this.valid_Cd +
            ", updateBy=" + this.updateBy + ", updateDt=" + this.updateDt + ", dObj_ParamNm=" + this.dObj_ParamNm + ", codepage=" + this.codepage +
            ", conn_Id=" + this.conn_Id + ", conn_Db_Id =" + this.conn_Db_Id + ", transient_ScopeFlg=" + this.transient_ScopeFlg +
            ", caseSensitiveFlg=" + this.caseSensitiveFlg + ", isPublicSynonym=" + this.isPublicSynonym + ", support_Net_Changes =" + this.support_Net_Changes +
            ", capture_Instance =" + this.capture_Instance;

        if (isNotCompare) {
            str += ", conn_Nm=" + this.conn_Nm + ", conn_DbNm=" + this.conn_DbNm + ", cdcFlag=" + this.cdcFlag + ", conn_DbTyp_Id=" + this.conn_DbTyp_Id +
                ", reNameDobj=" + this.reNameDobj + ", host=" + this.host + ", port=" + this.port + ", conn_Usr=" + this.conn_Usr +
                ", ref_Cd =" + this.ref_Cd + ", databaseNm=" + this.databaseNm + ", conn_Db_FriendlyName=" + this.conn_Db_FriendlyName +
                ", secKeyTab=" + this.secKeyTab + ", platform=" + this.platform + ", hiveServe2HACnf_Flg =" + this.hiveServe2HACnf_Flg +
                ", zookeeper_Quorum_Host=" + this.zookeeper_Quorum_Host + ", ref_Id=" + this.ref_Id + ", lastUpdateBy =" + this.lastUpdateBy +
                ", instSqlNm=" + this.instSqlNm + ", connType=" + this.connType +
                ", originalTableName=" + this.originalTableName;
        }

        str += ']';
        return str;
    }
}